import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from "@mui/styles/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from "react-router-dom";
import { faMinusCircle, faPlusCircle,faTrash } from '@fortawesome/free-solid-svg-icons'
import Grid from "@mui/material/Grid";
const useStyles = makeStyles({
  comapreItemCard: {
    backgroundColor: '#fafafa',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 10,
    marginTop: 15,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    borderStyle: "solid",
    opacity: 1,
    borderWidth: 0.35,
  },
  compareItemCardRight: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  details: {
    marginTop: 0,
    marginBottom: 0,
  },
  trashIcon: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 6,
    paddingRight: 6,
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    borderStyle: "solid",
    marginEnd: 10,
    opacity: 1,
  },
});
const ComapreItemCard = ({ title, count, id, loading, handleDelete }) => {
  const { t, i18n } = useTranslation();
  const navigate = useHistory();
  const styles = useStyles();
  const theme = useTheme();
  const handleDeleteItem = () => {
    if (handleDelete) {
      handleDelete(id);
    }
  }
  const handleItemPress = ()=>{
navigate.push("comparing-cart/"+id);
  }


  return (
  <Grid item  key={id ? id : "all  card"} 
  xs={12} sm={4} md={4}>
    <div
   // disabled={loading}
   
    className={styles.comapreItemCard}
    style={{ cursor:"pointer",borderColor: theme.light.primary,}}
  >

<div
   // disabled={loading}
    onClick={handleItemPress}
   
    style={{ cursor:"pointer",borderColor: theme.light.primary,}}
  >
    <div  className={styles.compareItemCardRight}>
      {!!title && <Typography>{`${title}`}</Typography>}
    </div>
    
  </div>
    
    <div
                            //disabled={cartLoading}
                            style={{cursor:"pointer",paddingRight: 8, paddingleft: 8, borderRadius: 4, marginTop: 10, marginBottom: 15 }}
                            onClick={() => handleDeleteItem()}
                        >
                             <FontAwesomeIcon  style={{ color: theme.light.primary, fontSize: 16 }} icon={faTrash} />
                        </div>
   
  </div>
  </Grid>) ;
}

export default ComapreItemCard;